import React, { Component } from 'react';
import { connect } from "react-redux";
import _ from 'underscore';
import MentorTimeTrackerUtils from '../../../lib/MentorTimeTrackerUtils';
import SearchSelectList from '../SearchSelectList';
import SearchSelectListItem from '../SearchSelectListItem';
import {
    getAccounts,
    addAccountFavorite,
    removeAccountFavorite
} from '../../../actions/userActions';
import { modalController } from "../../../actions/domActions";
import Highlighter from 'react-highlight-words';

// SASS Imports
require('./AccountSearchSelectList.scss');


function mapStateToProps (store) {
    return { favorites: store.favorites.accounts };
}

function mapDispatchToProps (dispatch, ownProps) {
    return {
        getAccounts: (filterQuery, size, from) =>
            dispatch(getAccounts({filterQuery, size, from})),
        showLocations: (account) =>
            dispatch(modalController("SHOW_LOCATIONS_FROM", {account})),
        showOpportunities: (account) =>
            dispatch(modalController("SHOW_OPPORTUNITIES_FOR", {account})),
        addFavorite: (account) =>
            dispatch(addAccountFavorite(account)),
        removeFavorite: (account) =>
            dispatch(removeAccountFavorite(account))
    };
}

class AccountSearchSelectList extends Component {
    constructor (props) {
        super(props);

        // we make a copy of the static list here, because we don't
        // want items to drop off the initial list as soon as a user
        // un-favorites them. this way the item remains, so they user can
        // favorited the item again, if they made a mistake. when the modal
        // is closed/re-opened, the updated list is shown.
        this.state = {
            staticList: (props.favorites) ? props.favorites.slice() : []
        };

        this.renderItem = this.renderItem.bind(this);
        this.onFetch = this.onFetch.bind(this);
    }

    onFetch (filterQuery, filters, size, from) {
        return this.props.getAccounts(filterQuery, size, from);
    }

    _wrap (highlightTokens, text) {
        return (
            <Highlighter
                highlightClassName="searchHighlight"
                searchWords={highlightTokens}
                textToHighlight={text}
                autoEscape={true}
            />
        );
    }

    _renderLocationHint (account, highlightTokens) {
        const hint = [];
        const locations = account.locations;

        if (locations.length > 0) {
            const location = MentorTimeTrackerUtils.selectMatchingLocation(
                highlightTokens,
                locations
            );

            if (location) {
                hint.push(
                    <div key="0">
                        {this._wrap(highlightTokens, location.city)}{", "}
                        {this._wrap(highlightTokens, location.region)}{" "}
                        {this._wrap(highlightTokens, location.countryCode)}
                    </div>
                );
            }

            if (locations.length > 1) {
                const plural = (locations.length - 1) === 1 ? '' : 's';
                const messaging = (location)
                    ? `${locations.length - 1} additional`
                    : String(locations.length);

                hint.push(
                    <a key="1" onClick={() => this.props.showLocations(account)}>
                        {messaging} location{plural}…
                    </a>
                );
            }
        }

        return hint;
    }

    _renderOpportunityHint (account) {
        const opportunities = account.opportunities;
        const plural = (opportunities.length - 1) === 0 ? "y" : "ies";
        let result = null;

        if (opportunities.length > 0) {
            result = (
                <a onClick={() => this.props.showOpportunities(account)}>
                    {opportunities.length} opportunit{plural}…
                </a>
            );
        }

        return result;
    }

    renderItem (account, props, searchValue) {
        const highlightTokens = searchValue.toLowerCase()
            .split(/\s+/)
            .filter((s) => s);

        return (
            <SearchSelectListItem
                item={account}
                key={account.accountId}
                rowClassName="accountListItem"
                selectText="Select Account"
                onSelectItem={this.props.onSelectItem}
                hasAddToFavorites={this.props.hasAddToFavorites}
                {...props}
            >
                <p className="itemId">
                    Account ID: #{this._wrap(highlightTokens, account.accountId)}
                </p>
                <h5 className="accountName">
                    {this._wrap(highlightTokens, account.accountName)}
                </h5>
                <p className="standardCompanyName">
                    {this._wrap(highlightTokens, account.company.standardCompanyName)}
                </p>
                <div className="location">
                    {this._renderLocationHint(account, highlightTokens)}
                </div>
                <div className="opportunity">
                    {this._renderOpportunityHint(account)}
                </div>
            </SearchSelectListItem>
        );
    }

    render () {
        return (
            <SearchSelectList
                title="Select Your Account"
                searchPlaceholder="Company Name and City..."
                filterPlaceholder="Filter By Location"
                staticListResults={this.state.staticList}
                onFetch={this.onFetch}
                itemProps={{
                    hasAddToFavorites: true,
                    onFavoriteItem: (account) =>
                        this.props.addFavorite(account),
                    onRemoveFavoriteItem: (account) =>
                        this.props.removeFavorite(account)
                }}
                renderItem={this.props.renderItem || this.renderItem}
                showFilter={false}
                {...this.props}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountSearchSelectList);



// WEBPACK FOOTER //
// ./app/components/SelectLists/Types/AccountSearchSelectList.jsx